import { IServer, IServerConnection, IServerResponse, IServerCommand, IConnectionStatus, IRetryPolicySettings, IServerConnectionLogger, IRetryInfo } from '../types';
import { Observable } from 'rxjs/Observable';
import { RetryPolicy } from '../utilities';

export class Server<TResponseStreamCollection> implements IServer {
    public streams: TResponseStreamCollection;
    protected connection: IServerConnection;
    private retryPolicy: RetryPolicy;

    constructor(connection: IServerConnection, createStreams: (stream$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>) => TResponseStreamCollection, retryPolicy?: IRetryPolicySettings) {
        this.connection = connection;
        this.streams = createStreams(this.connection.stream$, this.connection.error$, this.connection.connectionStatus$);
        this.retryPolicy = new RetryPolicy(this, this.connection.error$, this.connection.connectionStatus$, retryPolicy);
    }

    public url(): string {
        return this.connection.serverUrl;
    }

    public logger(): IServerConnectionLogger {
        return this.connection.logger();
    }

    public connect(retryInfo?: IRetryInfo, enableKeepAlive: boolean = true): Promise<any> {
        return this.connection.connect(retryInfo);
    }

    public disconnect(force: boolean = false): Promise<any> {
        return this.connection.disconnect(force);
    }

    public send(command?: IServerCommand): void {
        return this.connection.send(command);
    }

    public sendOfflineMessageBuffer(): void {
        this.connection.sendOfflineMessageBuffer();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/servers/base-server.ts